import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Text } from '@zillow/constellation';
import { SizePropType } from './prop-types.js';
import { BREAKPOINT_TABLET, BREAKPOINT_DESKTOP } from './constants.js';

var UpsellHeading = function UpsellHeading(_ref) {
  var children = _ref.children,
    size = _ref.size;
  return /*#__PURE__*/React.createElement(ForegroundText, {
    as: "p",
    fontType: getHeadingFont(size),
    marginBottom: getHeadingMarginBottom(size)
  }, children);
};
var ForegroundText = /*#__PURE__*/styled(Text).withConfig({
  componentId: "sc-1pug80p-0"
})(["color:var(--foreground);"]);
function getHeadingFont(size) {
  var _ref2, _ref3, _ref4;
  switch (size) {
    case 'xs':
      return _ref2 = {
        default: 'h4'
      }, _ref2[BREAKPOINT_DESKTOP] = 'h5', _ref2;
    case 'sm':
      return 'h4';
    case 'md':
      return _ref3 = {
        default: 'h4'
      }, _ref3[BREAKPOINT_TABLET] = 'h3', _ref3;
    case 'lg':
      return _ref4 = {
        default: 'h4'
      }, _ref4[BREAKPOINT_TABLET] = 'h3', _ref4[BREAKPOINT_DESKTOP] = 'h1', _ref4;
    default:
      throw new Error("Unexpected size of \"" + size + "\"");
  }
}
function getHeadingMarginBottom(size) {
  var _ref5;
  switch (size) {
    case 'xs':
      return undefined;
    case 'sm':
      return 'sm';
    case 'md':
    case 'lg':
      return _ref5 = {
        default: 'sm'
      }, _ref5[BREAKPOINT_TABLET] = 'md', _ref5;
    default:
      throw new Error("Unexpected size of \"" + size + "\"");
  }
}
UpsellHeading.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  size: SizePropType.isRequired
} : {};
var UpsellHeading$1 = UpsellHeading;

export { UpsellHeading$1 as default };
